export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_20.774d85a2.jpg";